
export default function Hero() {
  return (
    <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/02acab0e11a7637ac4a0684e8fd0eecc.jpg"
          alt="Contact Piano Movers UK — specialist piano removal London"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/55"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white w-full">
        <h1 className="text-5xl md:text-6xl font-serif font-bold mb-6">
          Contact Us
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-white/90 font-light">
          Get in touch with London&apos;s specialist piano removal team — free fixed-price quotes, no obligation
        </p>
        <a
          href="tel:02034419463"
          className="inline-flex items-center gap-2 bg-[#c9a84c] hover:bg-[#b8973d] text-[#0e0d0b] px-8 py-4 rounded-md text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-line text-xl" aria-hidden="true"></i>
          Call 020 3441 9463
        </a>
      </div>
    </section>
  );
}
